// @flow
import * as React from 'react';
import { Radio } from 'antd';

type Props = {
  filters: {
    active: string,
  },
  onChangeFilter: (key: string, value: any) => void,
}

export default ({ filters, onChangeFilter }: Props) => (
  <div style={{ marginBottom: 16 }}>
    <Radio.Group
      value={filters.active}
      onChange={(e) => onChangeFilter('active', e.target.value)}
      buttonStyle="solid"
    >
      <Radio.Button value="all">All Suppliers</Radio.Button>
      <Radio.Button value="active">Active</Radio.Button>
      <Radio.Button value="inactive">Inactive</Radio.Button>
    </Radio.Group>
  </div>
);
